import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'

const SummaryHeaderItem = ({
  height,
  width,
  isHighlighted = false,
}: {
  height: number
  width: number
  isHighlighted?: boolean
}) => {
  const { t } = useLocalize()
  return (
    <>
      <div
        className={`tw-relative tw-flex tw-flex-1 tw-items-end tw-justify-start tw-bg-base-200 tw-pb-[7px] tw-pl-1 tw-text-[10px] tw-font-medium tw-text-content-base ${isHighlighted ? 'tw-text-primary' : ''}`}
        style={{
          minWidth: width,
          height,
        }}
      >
        {isHighlighted && (
          <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-[#0034FF]/20" />
        )}
        <span className="tw-relative">{t('timesheet.together')}</span>
      </div>
      <div
        className={`tw-relative tw-flex tw-flex-1 tw-items-end tw-justify-start tw-bg-base-200 tw-pb-[7px] tw-pl-1 tw-text-[10px] tw-font-medium tw-text-content-base ${isHighlighted ? 'tw-text-primary' : ''}`}
        style={{
          minWidth: width,
          height,
        }}
      >
        {isHighlighted && (
          <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-[#0034FF]/20" />
        )}
        <span className="tw-relative">{t('timesheet.entire-period')}</span>
      </div>
    </>
  )
}

export default SummaryHeaderItem
